module.exports = __webpack_public_path__ + "img/delivery-service.a4fe33eb.png";